import styled, { css } from "styled-components";
import { BLUE, LIGHT_BLUE, NEAR_WHITE } from "../../config";

export const Separator = styled.span`
  margin: 8px;
  cursor: default;
  user-select: none;
  font-size: 20px;
`;

export const BreadCrumbItem = styled.span<{ isLast: boolean }>`
  cursor: pointer;
  outline: none;
  transition: 0.2s ease;
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;

  ${(props) =>
    props.isLast
      ? css`
          color: ${NEAR_WHITE};
          cursor: unset;
        `
      : css`
          &:hover {
            color: ${LIGHT_BLUE};
          }

          &:active {
            color: ${BLUE};
          }
        `}
`;
